var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCancel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M15.626 14.0989L15.6267 14.0996C15.7056 14.1779 15.75 14.2844 15.75 14.3956C15.75 14.5067 15.7056 14.6133 15.6267 14.6916L15.626 14.6923L14.6923 15.626L14.6916 15.6267C14.6133 15.7056 14.5067 15.75 14.3956 15.75C14.2844 15.75 14.1779 15.7056 14.0996 15.6267L14.0989 15.626L8.17678 9.70388L8 9.5271L7.82322 9.70388L1.90115 15.626L1.90043 15.6267C1.82215 15.7056 1.71559 15.75 1.60443 15.75C1.49327 15.75 1.38671 15.7056 1.30843 15.6267L1.3077 15.626L0.374046 14.6923L0.373318 14.6916C0.294394 14.6133 0.25 14.5067 0.25 14.3956C0.25 14.2844 0.294394 14.1779 0.37332 14.0996L0.374045 14.0989L6.29612 8.17678L6.47289 8L6.29612 7.82322L0.374045 1.90115L0.374046 1.90115L0.373318 1.90043C0.294394 1.82215 0.25 1.71559 0.25 1.60443C0.25 1.49327 0.294394 1.38671 0.373318 1.30843L0.37332 1.30843L0.374045 1.3077L1.3077 0.374045L1.30771 0.374046L1.30843 0.373318C1.38671 0.294394 1.49327 0.25 1.60443 0.25C1.71559 0.25 1.82215 0.294394 1.90043 0.373318L1.90042 0.37332L1.90115 0.374045L7.82322 6.29612L8 6.47289L8.17678 6.29612L14.0989 0.374046L14.0996 0.373319C14.1779 0.294394 14.2844 0.25 14.3956 0.25C14.5067 0.25 14.6133 0.294394 14.6916 0.37332L14.6923 0.374045L15.626 1.30771L15.6267 1.30843C15.7056 1.38671 15.75 1.49327 15.75 1.60443C15.75 1.71559 15.7056 1.82215 15.6267 1.90043L15.626 1.90115L9.70388 7.82322L9.5271 8L9.70388 8.17678L15.626 14.0989Z",
    fill: "#354052",
    stroke: "white",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancel);
export default __webpack_public_path__ + "static/media/cancel.e0e4899addccf8aca80476fcce8fdfbd.svg";
export { ForwardRef as ReactComponent };